export default {
  props: {
    marginTop: {
      type: Number,
      default: 40
    },
    marginRight: {
      type: Number,
      default: 40
    },
    marginLeft: {
      type: Number,
      default: 40
    },
    marginBottom: {
      type: Number,
      default: 40
    }
  },
  computed: {    
    graphWidth () {
      return this.width - this.marginLeft - this.marginRight
    },
    graphHeight () {
      return this.height - this.marginTop - this.marginBottom
    },
    graphTransform () {
      return 'translate(' + this.marginLeft + ',' + this.marginTop + ')'
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/d3vue/mixins/margin.js